// Mock data for Business Print landing page - Dublin, Ireland

export const heroData = {
  title: "Custom Printed Packaging & Folded Cartons in Ireland",
  subtitle: "Business Print produces high-quality printed packaging, folded cartons, sleeves and glued carton solutions for food, retail, cosmetics, supplements and promotional packaging.",
  description: "Short-run and custom packaging options available with fast turnaround from our Dublin facility.",
  ctaText: "Request a Quote",
  ctaSecondary: "View Our Services",
  heroImage: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/f32p64x1_HEI_1_Speedmaster_CX_75.jpg"
};

export const statsData = [
  { label: "Short-Run Specialists" },
  { label: "Fast Turnaround" },
  { label: "Irish-Based Production" },
  { label: "BRC Approved" },
  { label: "FSC Approved" },
  { label: "ISO 9001" },
  { label: "Litho Print with AQ Seal" },
  { label: "In House Finishing" },
  { label: "Prototyping" }
];

export const introData = {
  badge: "About Business Print",
  title: "Your Partner for Premium Printed Packaging in Ireland",
  content: "Business Print is an established commercial printer expanding into the printed packaging sector. Based in Dublin 12, we specialise in producing high-quality printed cartons, sleeves and glued packaging solutions for Irish businesses.\n\nWe offer short-run and custom packaging production, making us the ideal partner for product launches, seasonal campaigns and growing brands that need flexibility without compromising on quality.\n\nBy combining high-quality lithographic and digital printing with precision finishing and carton conversion capabilities, we deliver complete packaging solutions under one roof—reducing lead times and ensuring consistency across your entire packaging range.",
  image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/214lzpz9_cx75-narrow.jpg",
  badge2: "Dublin Based",
  badgeText: "Local production facility"
};

export const productsData = [
  {
    id: 1,
    title: "Printed Sleeves",
    description: "High-impact printed sleeves for product wrapping, bottle sleeves, and promotional overwraps. Perfect for beverages, cosmetics and gift packaging.",
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/atmmqiog_image.png",
    link: "#"
  },
  {
    id: 2,
    title: "Folded Cartons",
    description: "Custom folded cartons for retail packaging, pharmaceutical boxes, and consumer goods. Available in various board weights and finishes.",
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/ztntlr1e_Muffin-Boxes.webp",
    link: "#"
  },
  {
    id: 3,
    title: "Custom Presentation Box",
    description: "Bespoke printed packaging boxes tailored to your product specifications. Full colour printing with premium finishing options.",
    image: "https://images.unsplash.com/photo-1704118548764-502615104ca7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjb3NtZXRpYyUyMGJveHxlbnwwfHx8fDE3NzMyMTk3OTV8MA&ixlib=rb-4.1.0&q=85",
    link: "https://www.businessprint.ie/presentation-box/"
  },
  {
    id: 4,
    title: "Short Run Packaging",
    description: "Cost-effective short-run production for product launches, market testing, and seasonal promotions. Minimum order quantities to suit growing brands.",
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/t5cj86uk_Screenshot%202026-03-17%20at%2012.23.57.png",
    link: "https://www.businessprintpackaging.ie/pizza-box/products/"
  },
  {
    id: 5,
    title: "Retail Packaging",
    description: "Shelf-ready packaging designed to stand out at point of sale. Eye-catching designs with structural integrity for retail environments.",
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/mktwiv28_Screenshot%202026-03-17%20at%2013.04.42.png",
    link: "https://www.businessprint.ie/what-we-do/corrugated-display.html"
  },
  {
    id: 6,
    title: "Packaging Special Effects",
    description: "Enhance your packaging with premium special effects that capture attention. Gold foil, spot UV, embossing and debossing add depth, texture and visual impact to make your packaging unforgettable.",
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/hfr428tq_Screenshot%202026-03-17%20at%2012.43.07.png",
    link: "https://www.businessprint.ie/how-we-do-it/how-we-do-it-special-effects.html"
  }
];

export const cartonCapabilitiesData = [
  {
    id: 1,
    title: "Straight Line Gluing",
    description: "Standard carton construction ideal for retail packaging, pharmaceutical boxes and general consumer products. Reliable, cost-effective assembly with clean fold lines.",
    features: ["Cost-effective production", "Quick assembly", "Ideal for high-volume runs"],
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/o3zr3e5t_straight-line-box-newluolan.jpg"
  },
  {
    id: 2,
    title: "Crash Lock Base Cartons",
    description: "Self-erecting base design that pops into shape automatically. Perfect for heavier products requiring a stronger base support and faster packing line speeds.",
    features: ["Auto-erecting base", "Stronger base support", "Faster packing speeds"],
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/mkh4ebod_Crash-lock-bottom-box.jpg"
  },
  {
    id: 3,
    title: "4 Corner Cartons",
    description: "Four-corner glued trays ideal for presentation packaging, gift boxes and display trays. Provides excellent structural rigidity with premium appearance.",
    features: ["Premium presentation", "Excellent rigidity", "Display-ready design"],
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/6x7a6jnq_4-corners-box.jpg"
  },
  {
    id: 4,
    title: "6 Corner Cartons",
    description: "Six-corner construction for food trays, takeaway containers and applications requiring leak-resistant corners. Robust design for demanding applications.",
    features: ["Leak-resistant corners", "Food-safe options", "Robust construction"],
    image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/usjqi564_6-corners-box.jpg"
  }
];

export const dieCuttingData = {
  badge: "Precision Manufacturing",
  title: "Precision Die Cutting",
  subtitle: "Our precision die cutting capabilities ensure your packaging is cut and shaped to exact specifications. Whether you need standard carton blanks or complex custom shapes, our equipment delivers consistent quality across every production run.",
  features: [
    "Precise carton cutting and shaping",
    "Custom packaging shapes and windows",
    "Accurate finishing for branded packaging",
    "Reliable repeat quality for production runs",
    "Complex die shapes for unique designs",
    "Consistent tolerances across large volumes"
  ],
  description: "Precision die cutting is essential for presentation, assembly and product fit. Accurate cutting ensures your packaging looks professional, assembles correctly and protects your products during transit and retail display.",
  link: "https://www.businessprint.ie/how-we-do-it/how-we-do-it-die-cutting-and-gluing.html",
  linkText: "Learn more about our die cutting process",
  image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/s1m0b8m7_x800_bobst-sp103-104-106models-8937934.jpg"
};

export const industriesData = [
  {
    id: 1,
    icon: "UtensilsCrossed",
    title: "Food & Takeaway",
    description: "Food-safe packaging for prepared foods, bakery items, confectionery and takeaway containers. FSSC 22000 compliant materials available."
  },
  {
    id: 2,
    icon: "Sparkles",
    title: "Cosmetics & Beauty",
    description: "Luxury packaging for skincare, makeup, fragrances and beauty accessories. Premium finishes that reflect your brand positioning."
  },
  {
    id: 3,
    icon: "Pill",
    title: "Health & Supplements",
    description: "Compliant packaging for vitamins, supplements and wellness products. Tamper-evident options and regulatory-ready designs."
  },
  {
    id: 4,
    icon: "ShoppingBag",
    title: "Retail Products",
    description: "Shelf-ready packaging designed to maximise retail visibility. Eye-catching designs that drive purchase decisions."
  },
  {
    id: 5,
    icon: "Gift",
    title: "Promotional & Gift",
    description: "Premium presentation packaging for gift sets, corporate gifts and limited edition products. Special finishes that create memorable unboxing experiences."
  },
  {
    id: 6,
    icon: "Package",
    title: "E-commerce & Subscription",
    description: "Branded mailer boxes and subscription packaging designed for the unboxing experience. Durable construction for postal transit."
  }
];

export const whyChooseData = {
  badge: "Our Advantages",
  title: "Why Choose Business Print",
  subtitle: "As an established print company expanding into packaging, we bring decades of printing expertise to your packaging projects.",
  reasons: [
    {
      icon: "Gauge",
      title: "Short Run Packaging Production",
      description: "Lower minimum order quantities make us ideal for start-ups, product launches and seasonal campaigns."
    },
    {
      icon: "Clock",
      title: "Fast Turnaround",
      description: "Efficient production processes and local manufacturing mean shorter lead times for your packaging needs."
    },
    {
      icon: "Palette",
      title: "Custom Printed Solutions",
      description: "Full colour printing with CMYK and Pantone matching. Your brand colours reproduced accurately every time."
    },
    {
      icon: "Award",
      title: "High Quality Print & Finishing",
      description: "Lithographic and digital printing combined with premium finishing options including lamination, foiling and embossing."
    },
    {
      icon: "Scissors",
      title: "Precision Die Cutting & Gluing",
      description: "In-house cutting and gluing capabilities ensure your packaging is production-ready from a single supplier."
    },
    {
      icon: "MapPin",
      title: "Dublin / Ireland Based Supplier",
      description: "Local production means better communication, faster delivery and support for Irish businesses."
    }
  ]
};

export const faqData = {
  badge: "Common Questions",
  title: "Frequently Asked Questions",
  subtitle: "Find answers to common questions about our printed packaging services.",
  faqs: [
    {
      question: "What is the minimum order quantity for printed packaging?",
      answer: "Our minimum order quantities are designed to be flexible for Irish businesses. Depending on the product type and specifications, we can accommodate runs from as low as 250 units for certain packaging types. Contact us to discuss your specific requirements."
    },
    {
      question: "What types of board and materials do you use?",
      answer: "We work with a range of board materials including SBS (Solid Bleached Sulphate), FBB (Folding Box Board), and kraft board in various weights. Food-safe materials are available for food contact applications. We can advise on the most suitable material for your specific packaging needs."
    },
    {
      question: "What printing methods do you offer?",
      answer: "We offer both lithographic (offset) printing and digital printing. Litho printing provides excellent quality for medium to high volume runs, while digital printing is ideal for shorter runs and quick turnarounds. Both methods support full CMYK colour and Pantone matching."
    },
    {
      question: "What finishing options are available?",
      answer: "We offer a comprehensive range of finishing options including lamination (gloss, matt, soft-touch), spot UV, foiling (gold, silver, holographic), embossing, debossing, and die-cutting. Our in-house finishing capabilities ensure quality control and faster turnaround times."
    },
    {
      question: "How long does production typically take?",
      answer: "Production timelines vary based on the complexity of your packaging and current workload. For standard runs, typical turnaround is 2-3 weeks from approved artwork. Rush services are available for urgent requirements. We'll provide a specific timeline when you request a quote."
    },
    {
      question: "Do you offer design services?",
      answer: "While our primary focus is on production, we can recommend trusted design partners who specialise in packaging design. We work from your supplied print-ready artwork and can provide technical guidance on structural design and print specifications."
    },
    {
      question: "Can you supply food-safe packaging?",
      answer: "Yes, we can supply food-contact approved packaging materials that comply with EU regulations. We work with FSSC 22000 certified materials suitable for direct food contact applications including bakery boxes, confectionery packaging and takeaway containers."
    },
    {
      question: "Do you deliver across Ireland?",
      answer: "Yes, we deliver across the Republic of Ireland and Northern Ireland. Shipping costs and timelines depend on your location and order size. Most Irish deliveries are completed within 3-5 working days of dispatch from our Dublin facility."
    }
  ]
};

export const contactData = {
  company: "Business Print Packaging",
  address: "Dublin 12, Ireland",
  phone: "01 450 8616",
  phoneLink: "+35314508616",
  email: "sales@businessprint.ie",
  image: "https://customer-assets.emergentagent.com/job_carton-solutions-1/artifacts/kklah3ud_Screenshot%202026-03-17%20at%2013.16.42.png"
};

export const ctaData = {
  title: "Request a Quote for Your Packaging Project",
  subtitle: "Talk to our packaging team about your next project. Whether you need printed cartons, sleeves or custom packaging solutions, we're here to help bring your product packaging to life.",
  badge: "Get In Touch"
};

export const finalCtaData = {
  title: "Ready to Start Your Packaging Project?",
  description: "Get in touch with our team to discuss your printed cartons, sleeves or custom packaging requirements. We're here to help Irish businesses create outstanding packaging.",
  ctaText: "Request a Quote",
  ctaSecondary: "View Our Services"
};

export const contactFormData = {
  title: "Send Us Your Requirements",
  fields: [
    { name: "name", label: "Full Name", type: "text", placeholder: "John Doe", required: true },
    { name: "email", label: "Email Address", type: "email", placeholder: "john@example.com", required: true },
    { name: "phone", label: "Phone Number", type: "tel", placeholder: "+353...", required: true },
    { name: "message", label: "Message", type: "textarea", placeholder: "Tell us about your packaging requirements...", required: true }
  ],
  submitText: "Request a Quote"
};
